import { Form, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { parseNumeric } from "../../../helpers";

const RowTotalesAfectacionIGV = ({ totales }) => (
  <>
    {totales?.map((e, index) => (
      <Table.Summary.Row key={index}>
        <Table.Summary.Cell index={0} colSpan={6} align="right">
          <b>{e?.label}</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} align="right">
          {e.total}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    ))}
  </>
);
export const DetallePedidoVentaTableSummary = ({ data }) => {
  const form = Form.useFormInstance();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const detallepedidoventa = Form.useWatch("detallepedidoventa", form);
  const moneda = Form.useWatch("moneda", form);
  const moneda_prefijo = Form.useWatch("moneda_prefijo", form);
  const [sumTotalesAfectacionIGV, setSumTotalesAfectacionIGV] = useState([]);
  const [sumTotales, setSumTotales] = useState(null);
  const fn_CalcularTotales = (data, monedaprefijo, tipocambio) => {
    let montototalgravadas = 0;
    let montototalinafectas = 0;
    let montototalexoneradas = 0;
    let montoigvtotal = 0;
    let montototal = 0;
    let montosubtotal = 0;
    data?.forEach((e) => {
      if (e?.grupotipoafectacionigv === "OPE. GRAVADA") {
        montototalgravadas += parseFloat(e.valorventabruto);
      } else if (e?.grupotipoafectacionigv === "OPE. EXONERADA") {
        montototalexoneradas += parseFloat(e.valorventabruto);
      } else if (e?.grupotipoafectacionigv === "OPE. INAFECTA") {
        montototalinafectas += parseFloat(e.valorventabruto);
      }
      montoigvtotal += parseFloat(e.valorigv);
      montosubtotal += parseFloat(e.valorventabruto);
      montototal += parseFloat(e.valorventa);
    });
    montototalgravadas = parseNumeric(montototalgravadas, 2);
    montototalexoneradas = parseNumeric(montototalexoneradas, 2);
    montototalinafectas = parseNumeric(montototalinafectas, 2);
    montoigvtotal = parseNumeric(montoigvtotal, 2);
    montototal = parseNumeric(montototal, 2);
    monedaprefijo = monedaprefijo || activeEmpleado?.empresa?.moneda_prefijo;
    let totales = [];
    if (montototalgravadas > 0) {
      totales = [
        ...totales,
        {
          label: `Ope. Gravada ${monedaprefijo}`,
          total: montototalgravadas.toFixed(2),
        },
      ];
    }
    if (montototalexoneradas > 0) {
      totales = [
        ...totales,
        {
          label: `Ope. Exonerada ${monedaprefijo}`,
          total: montototalexoneradas.toFixed(2),
        },
      ];
    }
    if (montototalinafectas > 0) {
      totales = [
        ...totales,
        {
          label: `Ope. Inafecta ${monedaprefijo}`,
          total: montototalinafectas.toFixed(2),
        },
      ];
    }

    const montototal_monedabase = parseNumeric(
      montototal * Number(tipocambio),
      2,
    );
    setSumTotalesAfectacionIGV(totales);
    setSumTotales({ montoigvtotal, montototal, montototal_monedabase });
    form.setFieldsValue({
      montototalgravadas,
      montototalexoneradas,
      montototalinafectas,
      montoigvtotal,
      montosubtotal,
      montototal,
      montototal_monedabase,
    });
  };
  useEffect(() => {
    fn_CalcularTotales(detallepedidoventa, moneda_prefijo, 1);
  }, [detallepedidoventa, moneda_prefijo, 1]);
  return (
    <>
      <RowTotalesAfectacionIGV totales={sumTotalesAfectacionIGV} />
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={6} align="right">
          <b>IGV {moneda_prefijo}</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} align="right">
          {parseFloat(sumTotales?.montoigvtotal).toFixed(2)}
        </Table.Summary.Cell>
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={6} align="right">
          <b>Importe Total {moneda_prefijo}</b>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} align="right">
          {parseFloat(sumTotales?.montototal).toFixed(2)}
        </Table.Summary.Cell>
      </Table.Summary.Row>
      {moneda !== activeEmpleado?.empresa?.moneda && (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={6} align="right">
            <b>Importe Total {activeEmpleado?.empresa?.moneda_prefijo}</b>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            {parseFloat(sumTotales?.montototal_monedabase).toFixed(2)}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    </>
  );
};
